/**
 * Reitertitel und -reihenfolge von Umweltdaten und Unfalldaten an genau einer Stelle
 * (Phase 43, D-13): Die Reiterleiste der Formulare und der Hinweis "Folgende Felder wurden
 * geaendert" lesen dieselben Konstanten -- kein zweiter Wahrheitsort fuer die Titel.
 * Bewusst ohne React-Importe, damit auch node-Tests die Datei laden koennen.
 */

export const ENVIRONMENTAL_TAB_ORDER = [
  'produktion',
  'strom',
  'brennstoffe',
  'einsatzstoffe',
  'drehoefen',
  // Phase 38 (D-18): Position direkt neben "Drehöfen" laut Sketch 021.
  'frachten',
  'emissionsminderung',
  'steinbrueche',
  'wasser',
] as const;

export type EnvironmentalTab = (typeof ENVIRONMENTAL_TAB_ORDER)[number];

export const ENVIRONMENTAL_TAB_TITLES: Record<EnvironmentalTab, string> = {
  produktion: 'Produktion',
  strom: 'Strom',
  brennstoffe: 'Brennstoffe',
  einsatzstoffe: 'Einsatzstoffe',
  drehoefen: 'Drehöfen',
  frachten: 'Frachtenberechnung',
  emissionsminderung: 'Emissionsminderung',
  steinbrueche: 'Steinbrüche',
  wasser: 'Wasser',
};

export const ACCIDENT_TAB_ORDER = ['general', 'statistics', 'additional'] as const;

export type AccidentTab = (typeof ACCIDENT_TAB_ORDER)[number];

export const ACCIDENT_TAB_TITLES: Record<AccidentTab, string> = {
  general: 'Allgemeine Informationen',
  statistics: 'Unfallstatistik',
  additional: 'Weitere Angaben',
};
